import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Banner = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    pauseOnHover: true,
    fade: true,
  };

  const slides = [
    {
      id: 1,
      image: "/assets/images/24.jpg",
      title: "ابدأ مشروعك مع Pyramid",
      description: "ابتكار وإبداع في كل تصميم لتحقيق رؤيتك.",
    },
    {
      id: 2,
      image: "/assets/images/1.jpg",
      title: "تحويل الأفكار إلى واقع",
      description: "الجودة والدقة في كل تفصيلة من أعمالنا.",
    },
    {
      id: 3,
      image: "/assets/images/22.jpg",
      title: "تصاميم معمارية عصرية",
      description: "خلق مساحات أنيقة ومريحة تجمع بين الفن والوظيفة.",
    },
    {
      id: 4,
      image: "/assets/images/23.jpg",
      title: "روعة التفاصيل",
      description: "الاهتمام بأدق التفاصيل لتحقيق التفرد والتميز.",
    },
    {
      id: 5,
      image: "/assets/images/1002.png",
      title: "ابدأ مشروعك مع Pyramid",
      description: "ابتكار وإبداع في كل تصميم لتحقيق رؤيتك.",
    },
    {
      id: 6,
      image: "/assets/images/1000.png",
      title: "تحويل الأفكار إلى واقع",
      description: "الجودة والدقة في كل تفصيلة من أعمالنا.",
    },
    {
      id: 7,
      image: "/assets/images/103.png",
      title: "تصاميم معمارية عصرية",
      description: "خلق مساحات أنيقة ومريحة تجمع بين الفن والوظيفة.",
    },
  ];

  return (
    <div style={{ width: "100%", margin: "0 auto", position: "relative" }}>
      <Slider {...settings}>
        {slides.map((slide) => (
          <div key={slide.id}>
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "90vh",
                backgroundImage: `url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "0",
                overflow: "hidden",
              }}
            >
              {/* طبقة العتمة المتدرجة */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.3))",
                  zIndex: 1,
                }}
              ></div>

              {/* النص */}
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#fff",
                  textAlign: "center",
                  zIndex: 2,
                  maxWidth: "800px",
                  animation: "fadeInUp 1.5s ease-in-out",
                }}
              >
                <h2
                  style={{
                    fontSize: "52px",
                    fontWeight: "900",
                    marginBottom: "20px",
                    textShadow: "0 6px 20px rgba(0,0,0,0.5)",
                    lineHeight: 1.2,
                  }}
                >
                  {slide.title}
                </h2>
                <p
                  style={{
                    fontSize: "22px",
                    lineHeight: "1.6",
                    textShadow: "0 4px 15px rgba(0,0,0,0.4)",
                    marginBottom: "30px",
                  }}
                >
                  {slide.description}
                </p>
                <button
                  style={{
                    padding: "14px 36px",
                    backgroundColor: "#f4c542",
                    color: "#000",
                    border: "none",
                    borderRadius: "30px",
                    fontSize: "18px",
                    fontWeight: "700",
                    cursor: "pointer",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.4)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.backgroundColor = "#fff")}
                  onMouseLeave={(e) => (e.target.style.backgroundColor = "#f4c542")}
                  onClick={() => (window.location.href ="https://wa.me/201095176686?text=")}
                >
                  ابدأ مشروعك الآن
                </button>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* CSS لأنيميشن fadeInUp */}
      <style>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translate(-50%, -40%);
          }
          100% {
            opacity: 1;
            transform: translate(-50%, -50%);
          }
        }

        @media (max-width: 768px) {
          h2 {
            font-size: 32px !important;
          }
          p {
            font-size: 18px !important;
          }
          button {
            font-size: 16px !important;
            padding: 10px 28px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Banner;
